export const nlSEO = {
  title: "Professionele SEO Diensten",
  description: "Data-gedreven zoekmachine optimalisatie strategieën om uw zichtbaarheid, verkeer en conversies te verhogen.",
  subtitle: "Oplossingen voor Zoekmachineoptimalisatie",

  servicesTitle: "Onze SEO Expertise",
  servicesSubtitle: "Uitgebreide optimalisatiediensten voor al uw zoekmarketing behoeften",
  services: {
    technical: {
      title: "Technische SEO",
      description: "Verbeter de infrastructuur van uw website voor betere crawling en indexering door zoekmachines.",
      technologies: ["Site Audits", "Crawlbaarheid", "Indexering", "Schema Markup", "Core Web Vitals"]
    },
    content: {
      title: "Contentoptimalisatie",
      description: "Strategische keyword targeting en contentverbeteringen voor hogere rankings.",
      technologies: ["Keyword Research", "On-Page SEO", "Contentstrategie", "Metadata", "Semantische SEO"]
    },
    local: {
      title: "Lokale SEO",
      description: "Vergroot uw zichtbaarheid in lokale zoekopdrachten en Google Mijn Bedrijf vermeldingen.",
      technologies: ["Google Mijn Bedrijf", "Lokale Citations", "NAP Consistentie", "Lokale Keywords", "Reviews"]
    },
    ecommerce: {
      title: "E-commerce SEO",
      description: "Gespecialiseerde optimalisatie voor webshops om productzichtbaarheid te vergroten.",
      technologies: ["Product SEO", "Categoriepagina's", "Sitestructuur", "Paginering", "EAT-signalen"]
    },
    analytics: {
      title: "SEO Analytics",
      description: "Uitgebreide tracking en rapportage om prestaties te meten en te verbeteren.",
      technologies: ["Google Analytics", "Search Console", "Rank Tracking", "Conversie Tracking", "Data Analyse"]
    },
    strategy: {
      title: "SEO Strategie",
      description: "Aangepaste langetermijnplannen voor duurzame organische groei.",
      technologies: ["Concurrentieanalyse", "Roadmapping", "Verticale SEO", "Enterprise SEO", "Holistische Strategie"]
    }
  },

  processTitle: "Ons SEO Proces",
  processSteps: [
    {
      title: "Ontdekking & Audit",
      description: "Uitgebreide analyse van uw huidige SEO prestaties en kansen."
    },
    {
      title: "Keyword Research",
      description: "Identificatie van waardevolle zoektermen relevant voor uw bedrijf."
    },
    {
      title: "Technische Optimalisatie",
      description: "Verbeteren van website infrastructuur voor crawling en indexering."
    },
    {
      title: "Contentontwikkeling",
      description: "Content creëren en optimaliseren voor gebruikers en zoekmachines."
    },
    {
      title: "Implementatie",
      description: "Uitvoeren van alle technische en contentoptimalisaties op uw site."
    },
    {
      title: "Monitoring & Rapportage",
      description: "Prestaties volgen en data-gedreven aanpassingen maken."
    }
  ]
};

export const deSEO = {
  title: "Professionelle SEO-Dienstleistungen",
  description: "Datenbasierte Suchmaschinenoptimierungsstrategien zur Steigerung Ihrer Sichtbarkeit, Ihres Traffics und Ihrer Conversions.",
  subtitle: "Suchmaschinenoptimierungslösungen",

  servicesTitle: "Unsere SEO-Expertise",
  servicesSubtitle: "Umfassende Optimierungsdienste für alle Ihre Suchmarketing-Anforderungen",
  services: {
    technical: {
      title: "Technisches SEO",
      description: "Verbessern Sie die Infrastruktur Ihrer Website für besseres Crawling und Indexierung durch Suchmaschinen.",
      technologies: ["Site Audits", "Crawlability", "Indexierung", "Schema Markup", "Core Web Vitals"]
    },
    content: {
      title: "Content-Optimierung",
      description: "Strategisches Keyword-Targeting und Content-Verbesserungen für höhere Rankings.",
      technologies: ["Keyword Research", "On-Page SEO", "Content-Strategie", "Metadaten", "Semantisches SEO"]
    },
    local: {
      title: "Lokales SEO",
      description: "Steigern Sie Ihre Sichtbarkeit in lokalen Suchanfragen und Google My Business-Einträgen.",
      technologies: ["Google My Business", "Lokale Citations", "NAP-Konsistenz", "Lokale Keywords", "Bewertungen"]
    },
    ecommerce: {
      title: "E-Commerce SEO",
      description: "Spezialisierte Optimierung für Online-Shops zur Steigerung der Produkt-Sichtbarkeit.",
      technologies: ["Produkt-SEO", "Kategorie-Seiten", "Site-Struktur", "Paginierung", "EAT-Signale"]
    },
    analytics: {
      title: "SEO Analytics",
      description: "Umfassendes Tracking und Reporting zur Messung und Verbesserung der Leistung.",
      technologies: ["Google Analytics", "Search Console", "Rank Tracking", "Conversion Tracking", "Datenanalyse"]
    },
    strategy: {
      title: "SEO-Strategie",
      description: "Individuelle Langzeitpläne für nachhaltiges organisches Wachstum.",
      technologies: ["Wettbewerbsanalyse", "Roadmapping", "Vertikales SEO", "Enterprise SEO", "Ganzheitliche Strategie"]
    }
  },

  processTitle: "Unser SEO-Prozess",
  processSteps: [
    {
      title: "Entdeckung & Audit",
      description: "Umfassende Analyse Ihrer aktuellen SEO-Leistung und Chancen."
    },
    {
      title: "Keyword Research",
      description: "Identifizierung von wertvollen Suchbegriffen, die für Ihr Unternehmen relevant sind."
    },
    {
      title: "Technische Optimierung",
      description: "Verbesserung der Website-Infrastruktur für Crawling und Indexierung."
    },
    {
      title: "Content-Entwicklung",
      description: "Erstellung und Optimierung von Inhalten für Nutzer und Suchmaschinen."
    },
    {
      title: "Implementierung",
      description: "Umsetzung aller technischen und inhaltlichen Optimierungen auf Ihrer Website."
    },
    {
      title: "Monitoring & Reporting",
      description: "Leistungen verfolgen und datenbasierte Anpassungen vornehmen."
    }
  ]
};
export const enSEO = {
  // Hero Section
  title: "Professional SEO Services",
  description: "Data-driven search engine optimization strategies to increase your visibility, traffic, and conversions.",
  subtitle: "Search Engine Optimization Solutions",

  // Services Section
  servicesTitle: "Our SEO Expertise",
  servicesSubtitle: "Comprehensive optimization services for all your search marketing needs",
  services: {
    technical: {
      title: "Technical SEO",
      description: "Improve your website's infrastructure for better crawling and indexing by search engines.",
      technologies: ["Site Audits", "Crawlability", "Indexing", "Schema Markup", "Core Web Vitals"]
    },
    content: {
      title: "Content Optimization",
      description: "Strategic keyword targeting and content improvements for higher rankings.",
      technologies: ["Keyword Research", "On-Page SEO", "Content Strategy", "Metadata", "Semantic SEO"]
    },
    local: {
      title: "Local SEO",
      description: "Boost your visibility in local searches and Google My Business listings.",
      technologies: ["Google My Business", "Local Citations", "NAP Consistency", "Local Keywords", "Reviews"]
    },
    ecommerce: {
      title: "E-commerce SEO",
      description: "Specialized optimization for online stores to increase product visibility.",
      technologies: ["Product SEO", "Category Pages", "Site Structure", "Pagination", "EAT Signals"]
    },
    analytics: {
      title: "SEO Analytics",
      description: "Comprehensive tracking and reporting to measure and improve performance.",
      technologies: ["Google Analytics", "Search Console", "Rank Tracking", "Conversion Tracking", "Data Analysis"]
    },
    strategy: {
      title: "SEO Strategy",
      description: "Customized long-term plans for sustainable organic growth.",
      technologies: ["Competitive Analysis", "Roadmapping", "Vertical SEO", "Enterprise SEO", "Holistic Strategy"]
    }
  },

  // Process Section
  processTitle: "Our SEO Process",
  processSteps: [
    {
      title: "Discovery & Audit",
      description: "Comprehensive analysis of your current SEO performance and opportunities."
    },
    {
      title: "Keyword Research",
      description: "Identifying high-value search terms relevant to your business."
    },
    {
      title: "Technical Optimization",
      description: "Improving website infrastructure for search engine crawling and indexing."
    },
    {
      title: "Content Development",
      description: "Creating and optimizing content for both users and search engines."
    },
    {
      title: "Implementation",
      description: "Executing all technical and content optimizations across your site."
    },
    {
      title: "Monitoring & Reporting",
      description: "Tracking performance and making data-driven adjustments."
    }
  ]
};

export const frSEO = {
  // Hero Section
  title: "Services SEO Professionnels",
  description: "Stratégies d'optimisation pour les moteurs de recherche basées sur les données pour augmenter votre visibilité, trafic et conversions.",
  subtitle: "Solutions d'Optimisation pour les Moteurs de Recherche",

  // Services Section
  servicesTitle: "Notre Expertise SEO",
  servicesSubtitle: "Services d'optimisation complets pour tous vos besoins en marketing de recherche",
  services: {
    technical: {
      title: "SEO Technique",
      description: "Améliorez l'infrastructure de votre site pour un meilleur crawl et indexation par les moteurs de recherche.",
      technologies: ["Audits de Site", "Accessibilité", "Indexation", "Balises Schema", "Core Web Vitals"]
    },
    content: {
      title: "Optimisation de Contenu",
      description: "Ciblage stratégique de mots-clés et amélioration de contenu pour un meilleur classement.",
      technologies: ["Recherche de Mots-Clés", "SEO On-Page", "Stratégie de Contenu", "Métadonnées", "SEO Sémantique"]
    },
    local: {
      title: "SEO Local",
      description: "Boostez votre visibilité dans les recherches locales et les fiches Google My Business.",
      technologies: ["Google My Business", "Citations Locales", "Cohérence NAP", "Mots-Clés Locaux", "Avis Clients"]
    },
    ecommerce: {
      title: "SEO E-commerce",
      description: "Optimisation spécialisée pour les boutiques en ligne afin d'augmenter la visibilité des produits.",
      technologies: ["SEO Produit", "Pages Catégorie", "Structure de Site", "Pagination", "Signaux EAT"]
    },
    analytics: {
      title: "Analyse SEO",
      description: "Suivi et reporting complet pour mesurer et améliorer les performances.",
      technologies: ["Google Analytics", "Search Console", "Suivi de Position", "Suivi de Conversions", "Analyse de Données"]
    },
    strategy: {
      title: "Stratégie SEO",
      description: "Plans à long terme personnalisés pour une croissance organique durable.",
      technologies: ["Analyse Concurrentielle", "Planification", "SEO Vertical", "SEO Enterprise", "Stratégie Holistique"]
    }
  },

  // Process Section
  processTitle: "Notre Processus SEO",
  processSteps: [
    {
      title: "Découverte & Audit",
      description: "Analyse complète de vos performances SEO actuelles et des opportunités."
    },
    {
      title: "Recherche de Mots-Clés",
      description: "Identification des termes de recherche à forte valeur pour votre entreprise."
    },
    {
      title: "Optimisation Technique",
      description: "Amélioration de l'infrastructure du site pour le crawl et l'indexation."
    },
    {
      title: "Développement de Contenu",
      description: "Création et optimisation de contenu pour les utilisateurs et les moteurs de recherche."
    },
    {
      title: "Mise en Œuvre",
      description: "Exécution de toutes les optimisations techniques et de contenu sur votre site."
    },
    {
      title: "Surveillance & Reporting",
      description: "Suivi des performances et ajustements basés sur les données."
    }
  ]
};
